import React from "react";
import { Helmet } from "react-helmet";
import CtaSection from "../Components/internal-pages/Cta_Section";
import LeftImgrightContent from "../Components/internal-pages/Leftimg_rightContent";
import RightimgLeftContent from "../Components/internal-pages/Rightimg_leftContent";
import NogapRightImage from "../Components/internal-pages/No_gap_right_Img";
import ClinetsLogoSlider from "../Components/home/ClientsLogoSlider";
import Whychooseus from "../Components/internal-pages/WhyChooseus";

const EmployeeRecognition =()=>{
    const CTAContent = [
        {
          pageName: "Employee Recognition ",
          paragraphitalic: "Celebrate Your Team with Meaningful Recognition ",
          paragraphText:
            "At eYantra, we understand that employees are the backbone of any successful organization. That's why our Employee Recognition Solutions are crafted to help you appreciate and celebrate your team in ways that inspire loyalty, motivation, and pride. Whether it's a warm welcome, a thoughtful reward, or a recognition program that keeps spirits high, we have you covered every step of the way.",
          ContactFormName: "Employee Recognition",
        },
      ];
    
      const ContentImg = [
        {
          index: 0,
          leftImg: "./assests/images/banners/Joining Kits Banner.jpg",
          leftHeading: "Joining Kits",
          leftSmallpara: "The Perfect Start to a New Journey",
          leftParagraph:
            "Welcome new employees with a thoughtful joining kit that sets the stage for a successful journey. Our customized joining kits are designed to help new hires feel instantly valued, excited, and equipped to dive into their new role. With personalized items and essentials, our kits ensure that the first impression counts.",
          leftRedirectUrl: "/employee-recognition/joining-kits",
        },
        {
          index: 1,
          leftImg: "./assests/images/banners/Rewards & Recognition (R&R) Banner.jpg",
          leftHeading: "Rewards & Recognition (R&R)",
          leftSmallpara: "Acknowledge Excellence and Drive Motivation",
          leftParagraph:
            "Celebrate milestones, achievements, and hard work with our Rewards & Recognition (R&R) Solutions. Whether it's rewarding top performers, celebrating anniversaries, or recognizing everyday contributions, our R&R programs offer a variety of meaningful gift options that motivate and inspire.",
          leftRedirectUrl: "/employee-recognition/reward-and-recognition",
        },
      ];
      const rightImgContent = [
        {
          index: 0,
          rightImg: "./assests/images/banners/Welcome Kits Banner.png",
          rightHeading: "Welcome Kits ",
          rightSmallpara: "A Thoughtful Introduction to Your Brand",
          rightParagraph:
            "Our Welcome Kits are more than just a collection of items—they’re a powerful introduction to your company’s values, vision, and team. These kits are designed to ensure new employees feel appreciated, motivated, and ready to take on the world.",
          rightRedirectUrl: "/employee-recognition/welcome-kits",
        },
      ];
    
    return(
        <>
        <Helmet>
            <title>eYantra Corporate Gifting & Merchandise</title>
            <meta name="description" content="eYantra offers corporate gifts, joining kits, onboarding solutions, and personalised business items with premium company merchandise for employees."/>
            <meta name="keywords" content="eyantra, corporate gifting, joining kits, rewards and recognitions, onboarding kits for employees, corporate gifts for employees, welcome kits, personalised business items, company merchandise"/>
        </Helmet>
        <div className="p-0 m-2">
        <CtaSection data={CTAContent} />

        <LeftImgrightContent leftImgContent={ContentImg[0]} />
        <RightimgLeftContent data={rightImgContent[0]} />
        <LeftImgrightContent leftImgContent={ContentImg[1]} />
        </div>
        <div className="my-5">
            <ClinetsLogoSlider/>
        </div>
        <Whychooseus/>
     
        </>
    )
}

export default EmployeeRecognition;